import { assert } from '@/core'
import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class TransactionsService extends BaseService {
  static get entity() {
    return 'transactions'
  }

  static async create(payload = {}) {
    assert.object(payload, { required: true })
    assert.number(payload.amount, { required: true })
    assert.string(payload.message, { required: true })
    assert.string(payload.transacType, { required: true })

    try {
      const response = await this.request({ auth: true }).post(`${this.entity}`, {
        ...payload,
      })
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async getList(params = {}) {
    assert.object(params, { required: true })

    try {
      const response = await this.request({ auth: true }).get(
        `finances?${this.querystring(params)}`
      )

      const data = {
        content: response.data.data,
        total: response.data.total,
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}
